import { normalizeBrandId } from "@/modules/brandId";

const rawDataLayerBrands = process.env.VUE_APP_DATALAYER_BRANDS;

function parseBrandList(raw) {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((item) => typeof item === "string" && item.trim())
      .map((item) => item.trim().toUpperCase());
  } catch (e) {
    console.error("Failed to parse VUE_APP_DATALAYER_BRANDS:", e);
    return [];
  }
}

const dataLayerBrands = parseBrandList(rawDataLayerBrands);

export function getDataLayerBrandId(brandId) {
  return normalizeBrandId(brandId);
}

export function isDataLayerBrand(brandId) {
  const normalized = normalizeBrandId(brandId);
  if (!normalized) return false;
  return dataLayerBrands.includes(normalized);
}

export function getDataLayerBrands() {
  return [...dataLayerBrands];
}
